/**
 * Date helpers — locale from static i18n instance (not React hooks).
 * App languages: `en` | `ua` only.
 */

import i18n from '../i18n/i18n.module';

const UA_MONTHS_SHORT = [
  'січ.',
  'лют.',
  'бер.',
  'квіт.',
  'трав.',
  'черв.',
  'лип.',
  'серп.',
  'вер.',
  'жовт.',
  'лист.',
  'груд.',
] as const;

const EN_MONTHS_SHORT = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
] as const;

function getAppLanguage(): 'en' | 'ua' {
  const lang = (i18n.language || 'en').toLowerCase().split('-')[0];
  return lang === 'ua' ? 'ua' : 'en';
}

function toValidDate(date: unknown): Date | null {
  if (!date) {
    return null;
  }
  const parsed = new Date(date as string | number | Date);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }
  return parsed;
}

function pad2(value: number): string {
  return String(value).padStart(2, '0');
}

function formatParts(date: Date, withTime: boolean): string {
  const language = getAppLanguage();
  const months = language === 'ua' ? UA_MONTHS_SHORT : EN_MONTHS_SHORT;
  const datePart = `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
  if (!withTime) {
    return datePart;
  }
  return `${datePart}, ${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
}

/**
 * Date only — locale-aware.
 * ua: 30 вер. 2026
 * en: 30 Sept 2026
 */
export const getDate = (date: unknown): string => {
  const parsed = toValidDate(date);
  if (!parsed) {
    return '';
  }
  return formatParts(parsed, false);
};

/**
 * Date + time — locale-aware.
 * ua: 30 вер. 2026, 15:44
 * en: 30 Sept 2026, 15:44
 */
export const getDateTime = (date: unknown): string => {
  const parsed = toValidDate(date);
  if (!parsed) {
    return '';
  }
  return formatParts(parsed, true);
};
